import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { PermissionOutput } from './models/permission.model';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private apiUrl = `${environment.apiUrl}/permission`;

  constructor(private http: HttpClient) { }

  getTree(): Observable<PermissionOutput[]> {
    return this.http.get<PermissionOutput[]>(`${this.apiUrl}/tree`, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 200) {
          throw new Error('Erro ao buscar árvore de permissões.');
        }
        return response.body || [];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }
}
